<div class="container" >
  <!-- *ngIf="isCradleOnline; else cradleOfflineMsg" -->
  <mat-card class="section" appearance="outlined">
    <mat-card-content class="action-items">
      <div class="actions">
        <mat-form-field class="example-form-field">
          <mat-label>Ring Count</mat-label>
          <input  matInput type=number [(ngModel)]="ringCount">
        </mat-form-field>
        <mat-label>Ring duration (in seconds): </mat-label>
            <mat-slider min="0" max="2.5" step="0.005" showTickMarks discrete>
              <input
                matSliderThumb
                [(ngModel)] = "ringInterval"
              />
            </mat-slider>
            <mat-checkbox [(ngModel)]="hasSecondaryInterval">Second interval duration (in seconds): </mat-checkbox>
            <mat-slider [disabled]="!hasSecondaryInterval" min="0" max="2.5" step="0.005" showTickMarks discrete>
              <input
                matSliderThumb
                [(ngModel)] = "ringInterval2"
              />
            </mat-slider>
        <button mat-fab extended (click)="ringBell()" [disabled]="ringCount<=0" [ngClass]="{stopColor:configStatus.isRinging}">
          <mat-icon>crib</mat-icon>
         Ring
        </button>
      </div>
      <div class="actions">
        <button mat-fab extended (click)="dispatchAction(CradleCommands.STOP,0)" [ngClass]="{stopColor:true}">
          <mat-icon>crib</mat-icon>
          Stop
        </button>
      </div>
      <div class="actions">
        <button mat-fab extended (click)="dispatchAction(CradleCommands.EMERGENCY_STOP,0)" [ngClass]="{stopColor:true}">
          <mat-icon>crib</mat-icon>
          Emergency Stop
        </button>
      </div>
      <mat-form-field class="example-form-field">
        <mat-label>Screen Pin (4 digits): </mat-label>
        <input #screenPin="ngModel" (keydown)="preventDecimal($event)" (paste)="$event.preventDefault()" matInput type=number min="1000" max="9999" maxlength="4" [ngModel]="configStatus.screenPin">
        <button [disabled]="screenPin.invalid || !screenPin.value" (click)="updateConfig(CradleCommands.SET_LOCK_SCREEN_PIN, screenPin.value)">Update Pin</button>
      </mat-form-field>
      <div class="actions">
        <mat-label>Controller screen timeout: {{configStatus.screenTimeout}} secs</mat-label>
        <mat-slider min="1" max="1200" step="1" showTickMarks discrete>
          <input
            matSliderThumb
            [ngModel]="configStatus.screenTimeout"
            (ngModelChange)="updateConfig(CradleCommands.SET_LOCK_SCREEN_TIMEOUT, $event)"
          />
        </mat-slider>
      </div>
      <span>Current Device Time: </span>
      <span>{{configStatus.deviceTime}}</span>
      <span>Temperature: {{configStatus.temperature}}</span>
      <span>Humidity: {{configStatus.humidity}}</span>
      <mat-form-field>
        <mat-label>Choose a date</mat-label>
        <input matInput [matDatepicker]="dtPicker" [(ngModel)]="selectedDate">
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="dtPicker"></mat-datepicker-toggle>
        <mat-datepicker #dtPicker ></mat-datepicker>
      </mat-form-field>
      <div style="display:flex; flex-direction: row; max-width: 200px; justify-content: space-between;">
        <mat-form-field appearance="outline" style="width: 60%;">
          <mat-label>Time</mat-label>
          <input
            type="text"
            matInput
            [ngxMatTimepicker]="timepicker"
            [format]="24"
            [(ngModel)]="selectedTime"
            readonly
          />
          <mat-icon
            matSuffix
            (click)="openTimeFromIcon(timepicker)"
            >schedule</mat-icon
          >
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 35%;">
        <mat-label>Seconds</mat-label>
        <input
          type="number"
          min="0"
          max="59"
          step="1"
          matInput
          [(ngModel)]="selectedSeconds"
        />
      </mat-form-field>
    </div>
      <ngx-mat-timepicker #timepicker ></ngx-mat-timepicker>
      <div class="actions">
        <button [disabled]="selectedDate==null || selectedTime==null"  mat-fab extended (click)="syncFromSelectedDate()" >
          <mat-icon>schedule</mat-icon>
          Sync From Above selected Date
        </button>
      </div>

      <div class="actions">
        <button mat-fab extended (click)="syncFromSystemDate()" >
          <mat-icon>schedule</mat-icon>
          Sync From System Date
        </button>
      </div>

      <div class="actions">
        <button mat-fab extended (click)="dispatchDummyData()">
          <mat-icon>present_to_all</mat-icon>
          Dispatch Dummy data for demo.
        </button>
      </div>
      <!-- <ngx-mat-timepicker
  #picker
  [enableKeyboardInput]="true"
  [max]="12"
  [min]="0"
></ngx-mat-timepicker> -->
    </mat-card-content>
  </mat-card>
  <mat-accordion class="section">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Adjust tuning </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-card class="container" appearance="outlined">
        <mat-card-content class="action-items">

          <div class="actions">
            <mat-label>Set slowest speed: {{configStatus.minMovingSpeed}}</mat-label>
            <mat-slider min="0" max="100" step="0.5" showTickMarks discrete>
              <input
                matSliderThumb
                [ngModel]="configStatus.minMovingSpeed"
                (ngModelChange)="updateConfig(CradleCommands.SET_MIN_MOVING_SPEED, $event)"
              />
            </mat-slider>
          </div>

          <div class="actions">
            <mat-label>Set Slow speed (between hit and return): {{configStatus.slowSpeed}}</mat-label>
            <mat-slider min="0" max="100" step="0.5" showTickMarks discrete>
              <input
                matSliderThumb
                [ngModel]="configStatus.slowSpeed"
                (ngModelChange)="updateConfig(CradleCommands.SET_SLOW_SPEED, $event)"
              />
            </mat-slider>
          </div>

          <div class="actions">
            <mat-label>Set speed for pulling bell: {{configStatus.speed}}</mat-label>
            <mat-slider min="0" max="100" step="1" showTickMarks discrete>
              <input
                matSliderThumb
                [ngModel]="configStatus.speed"
                (ngModelChange)="updateConfig(CradleCommands.SET_SWING_SPEED, $event)"
              />
            </mat-slider>
          </div>

          <div class="actions">
            <mat-label>Set reverse push speed: {{configStatus.reverseSpeed}}</mat-label>
            <mat-slider min="0" max="100" step="1" showTickMarks discrete>
              <input
                matSliderThumb
                [ngModel]="configStatus.reverseSpeed"
                (ngModelChange)="updateConfig(CradleCommands.SET_REVERSE_SWING_SPEED, $event)"
              />
            </mat-slider>
          </div>

          <div class="actions">
            <mat-label>Scheduler check interval (seconds): {{configStatus.schedulerCheckInterval}}</mat-label>
            <mat-slider min="0" max="900" step="5" showTickMarks discrete>
              <input
                matSliderThumb
                [ngModel]="configStatus.schedulerCheckInterval"
                (ngModelChange)="updateConfig(CradleCommands.SET_SCHEDULER_CHECK_INTERVAL, $event)"
              />
            </mat-slider>
          </div>

          <div class="actions">
            <mat-label>Init Point: {{configStatus.initPoint}}</mat-label>
            <mat-slider min="0" max="50" step="1" showTickMarks discrete>
              <input
                matSliderThumb
                [ngModel]="configStatus.initPoint"
                (ngModelChange)="updateConfig(CradleCommands.SET_INIT_POINT, $event)"
              />
            </mat-slider>
          </div>
          <div class="actions">
            <mat-label>Hit Point: {{configStatus.hitPoint}}</mat-label>
            <mat-slider min="0" max="50" step="1" showTickMarks discrete>
              <input
                matSliderThumb
                [ngModel]="configStatus.hitPoint"
                (ngModelChange)="updateConfig(CradleCommands.SET_HIT_POINT, $event)"
              />
            </mat-slider>
          </div>



        </mat-card-content>
      </mat-card>
    </mat-expansion-panel>
  </mat-accordion>
</div>
<ng-template #cradleOfflineMsg>
  <mat-card class="section">
    <mat-card-header><strong>Cradle Offline</strong></mat-card-header>
    <mat-card-content class="action-items">
      <span
        >Cradle is not connected. Please turn on cradle or connect it to
        internet.</span
      >
      <button mat-fab extended (click)="dispatchAction(CradleCommands.PUBLISH_CURRENT_STATUS,0)">
        <mat-icon>refresh</mat-icon>
        Refresh Status
      </button>
    </mat-card-content>
  </mat-card>
</ng-template>
